// https://us.app.unleash-hosted.com/usgg0011/projects/owner-hermes/features/hermes.caslGuestImportEbr
export const CASL_GUEST_IMPORT_EBR_FLAG = 'hermes.caslGuestImportEbr'

export function isGuestImportBlockedForCanadianBrand(
  country: string | null | undefined,
  ebrEnabled: boolean
): boolean {
  return country === 'CA' && !ebrEnabled
}
